import { useDispatch, useSelector } from "react-redux";
import { agencyApplicationSelector } from "../../../redux/selector/agencyApplicationSelector";
import { applicationTypeFromLicenceSubType } from "../../../redux/slice/applicationsUtils";
// import TopNavigationBar from "../../TopNavigationBar";
import { Paragraph, Button } from "../../../components/RegularComponents";
import {
  APPLICATION_MODE_NEW,
  APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_LICENCE,
  APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_LICENCE,
  APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE,
  ROUTE_PATH
} from "../../../app/constants";
import { push } from "connected-react-router";
import { replaceUrlParams } from "../../../app/utils";

export const MainAgentChangeRequestSubmitConfirmation = (props) => {
  // const {applicationMode} = props.match.params
  const { agencyApplication } = useSelector(agencyApplicationSelector) || {};
  const licencingSubType = agencyApplication?.licencingSubType;
  const applicationType = applicationTypeFromLicenceSubType(licencingSubType);
  const mainAgentTypeString = getMainAgentTypeString(applicationType);

  const dispatch = useDispatch();

  const handleReturnHome = () => {
    dispatch(push(replaceUrlParams(ROUTE_PATH.WELCOME, applicationType, APPLICATION_MODE_NEW)));
  };

  return (
    <div className="container">
      {/* Top navigation is not required.
          <TopNavigationBar {...props} applicationType={applicationType} applicationMode={applicationMode} /> 
          */}
      {/* Title */}
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <h1>{`New ${mainAgentTypeString} Application`}</h1>
        </div>
      </div>

      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <Paragraph
            id="new-agent-email-info-1"
            text={[`Your request for a new ${mainAgentTypeString} has been submitted.`]}
          />
        </div>
      </div>

      <div className="row">
        <div className={"col-lg-4"}>
          <Button
            id="change-reason-save-button"
            style={{ margin: "0 10px 10px 0" }}
            buttonType={"regular_primary"}
            text="Return home"
            onClick={handleReturnHome}
          />
        </div>
      </div>
    </div>
  );
};

function getMainAgentTypeString(applicationType) {
  switch (applicationType) {
    case APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE:
    case APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_LICENCE:
    case APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_LICENCE:
      return "Principal Broker";

    default:
      return "Compliance Officer";
  }
}
